export const siteInfo = {
  name: "51黑料网",
  shortName: "51黑料",
  slogan: "今日黑料最新 · 黑料每日更新",
  description: "51黑料网成立于2022年，是国内领先的娱乐八卦与热门爆料聚合平台。我们致力于为网友提供最新、最快、最全的黑料资讯，覆盖娱乐圈、直播圈、影视圈、音乐圈、体育圈、时尚圈、科技圈等多个领域。每日更新海量新鲜内容，让你不错过任何一个热点。",
  founded: "2022年",
  email: "contact@51heiliaowang.com",
  phone: "400-888-5151",
  address: "北京市朝阳区望京SOHO T3座 1808室",
  wechat: "heiliaowang51",
  weibo: "@51黑料网",
  reputation: [
    {
      title: "日活用户突破 500 万",
      description: "平台日均活跃用户超过500万，累计注册用户突破3000万，稳居行业前三。",
      icon: "ri-user-star-line",
    },
    {
      title: "内容覆盖 8 大领域",
      description: "涵盖娱乐圈、直播圈、影视圈、音乐圈、体育圈、时尚圈、科技圈、网络热闻等八大板块。",
      icon: "ri-stack-line",
    },
    {
      title: "日均更新 200+ 条",
      description: "专业编辑团队7x24小时追踪热点，日均更新超200条高质量黑料内容。",
      icon: "ri-flashlight-line",
    },
    {
      title: "行业权威认证",
      description: '先后获得"年度最佳内容平台"、"最受用户信赖的娱乐资讯平台"等多项行业大奖。',
      icon: "ri-award-line",
    },
  ],
  faq: [
    {
      question: "51黑料网的内容来源是哪里？",
      answer: "51黑料网的内容来源于编辑团队的多渠道搜集整理，包括社交媒体公开信息、网友投稿爆料、行业内部人士提供等。所有内容均经过编辑审核，确保信息的真实性和可读性。",
    },
    {
      question: "如何在51黑料网投稿爆料？",
      answer: "您可以通过网站底部的「联系我们」表单提交爆料内容，或发送邮件至 contact@51heiliaowang.com。我们会安排编辑与您对接，并对爆料人信息严格保密。",
    },
    {
      question: "51黑料网的内容更新频率是怎样的？",
      answer: "51黑料网实行7×24小时不间断更新机制。编辑团队分三班轮值，确保第一时间捕捉热点。通常情况下，热门事件发生30分钟内即可在平台看到相关报道。",
    },
    {
      question: "如何使用51黑料网的分类浏览功能？",
      answer: "您可以在首页顶部导航栏选择感兴趣的分类标签，或在首页中部通过分类Tab切换不同领域的内容。每个分类页面都会展示该领域最新、最热的黑料内容。",
    },
    {
      question: "51黑料网有移动端App吗？",
      answer: "目前51黑料网的移动端适配版已全面上线，您可以在手机浏览器中直接访问网站获得流畅的移动端体验。原生App正在开发中，敬请期待。",
    },
  ],
};